
export const comingSoonMixins = {
	methods: {
		showComingSoonAlert() {
			this.$swal({
				imageHeight: '150px',
				imageUrl: `${require('@/assets/images/_shared/coming-soon.png')}`,
				imageAlt: 'Coming Soon Dog',
				title: 'Coming Soon!',
				text: `This feature is under development.`,
				confirmButtonColor: '#4B8BFF',
				confirmButtonText: 'Got it'
			});
		}
	}
}